// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceFilterPopup_root__3k3d4","label":"PriceFilterPopup_label__1pTcY","labelSelected":"PriceFilterPopup_labelSelected__3lfCd"};